import { ReactComponent as Icon } from "./word-icon.svg";

type ExcelIconProps = {
	className?: string;
};

const WordIcon: React.FunctionComponent<ExcelIconProps> = ({className}) => {
	return <Icon className={className}/>;
};

export default WordIcon;